import { motion } from 'framer-motion';
import { Cpu, Instagram, Youtube, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      className="border-t border-border/40 mt-20"
      style={{ background: 'oklch(0.10 0.022 280)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div
                className="w-9 h-9 rounded-lg flex items-center justify-center"
                style={{ background: 'linear-gradient(135deg, var(--primary), var(--accent))' }}
              >
                <Cpu className="w-5 h-5 text-white" />
              </div>
              <span
                className="text-xl font-bold tracking-widest text-foreground"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                SOKAO<span className="text-primary">-TOYS</span>
              </span>
            </div>
            <p
              className="text-muted-foreground text-sm leading-relaxed max-w-sm"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Figurki projektowane przez AI, modelowane w Meshy AI i drukowane z najwyższą precyzją FDM.
              Każda figurka to unikalna historia.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { icon: <Instagram className="w-4 h-4" />, href: '#' },
                { icon: <Youtube className="w-4 h-4" />, href: '#' },
                { icon: <Twitter className="w-4 h-4" />, href: '#' },
              ].map((s, i) => (
                <motion.a
                  key={i}
                  href={s.href}
                  whileHover={{ scale: 1.15, y: -2 }}
                  className="w-9 h-9 rounded-lg border border-border/50 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors"
                >
                  {s.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4
              className="text-xs font-bold tracking-widest text-muted-foreground mb-5"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              SKLEP
            </h4>
            <ul className="space-y-3">
              {['Kolekcja Sci-Fi', 'Kolekcja Fantasy', 'Figurki z Filmów', 'Bajkowe', 'Personalizowane'].map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4
              className="text-xs font-bold tracking-widest text-muted-foreground mb-5"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              INFORMACJE
            </h4>
            <ul className="space-y-3">
              {['O nas', 'Jak drukujemy', 'Regulamin', 'Polityka prywatności', 'Kontakt'].map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    style={{ fontFamily: 'Rajdhani, sans-serif' }}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="mt-10 pt-6 border-t border-border/30 flex flex-col sm:flex-row items-center justify-between gap-3"
        >
          <span
            className="text-xs text-muted-foreground/60"
            style={{ fontFamily: 'JetBrains Mono, monospace' }}
          >
            © {new Date().getFullYear()} SOKAO-TOYS. Wszystkie prawa zastrzeżone.
          </span>
          <span
            className="text-xs text-muted-foreground/50"
            style={{ fontFamily: 'JetBrains Mono, monospace' }}
          >
            AI DESIGN · MESHY 3D · FDM PRINT
          </span>
        </div>
      </div>
    </footer>
  );
}
